import AiBadge from "@via/components/ai-badge";
import TagsCell from "@via/components/tags-cell.tsx";
import { EMPTY_TABLE_MESSAGE } from "@via/utils/constants.tsx";
import { EmptyDataIcon } from "@via/utils/custom-icons";
import {
  PipelineInterface,
  PipelineListProps,
} from "@via/utils/interfaces.tsx";
import type { JSX } from "react";
import { Link } from "react-router-dom";

export default function PipelineTable({
  pipelines,
}: PipelineListProps): JSX.Element {
  if (!pipelines || pipelines.length === 0) {
    return (
      <div className="via-generic-error">
        <EmptyDataIcon />
        <p>{EMPTY_TABLE_MESSAGE.PIPELINES}</p>
      </div>
    );
  }
  return (
    <div className="mt-6 overflow-x-auto rounded-lg bg-white drop-shadow-md">
      <table className="min-w-full divide-y divide-gray-200 text-left text-sm">
        <thead className="bg-gray-50 text-xs font-semibold uppercase text-gray-500">
          <tr>
            <th className="px-4 py-3">Name</th>
            <th className="px-4 py-3">Summary</th>
            <th className="px-4 py-3">Tags</th>
            <th className="px-4 py-3">Owner</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {pipelines.map((pipeline: PipelineInterface) => (
            <tr
              key={pipeline.id}
              data-testid={`pipeline-row-${pipeline.id}`}
              className="hover:bg-gray-50">
              <td className="px-4 py-3 font-medium text-gray-900">
                <Link
                  to={`${pipeline.id}`}
                  className="inline-flex items-center gap-2 hover:text-indigo-600">
                  {pipeline.name}
                  {Boolean(pipeline.aiEntity) && <AiBadge />}
                </Link>
              </td>
              <td className="max-w-md px-4 py-3 text-gray-500">
                <p className="line-clamp-2">{pipeline.summary}</p>
              </td>
              <td className="px-4 py-3">
                <TagsCell
                  tags={pipeline.tags ?? []}
                  rowId={pipeline.id}
                  variant="table"
                />
              </td>
              <td className="px-4 py-3 text-gray-500">{pipeline.ownerName}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
